"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Workflow case info converter.
 *
 * @author VBr
 */


var WorkflowCaseInfoConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WorkflowCaseInfoConverter, _DataObjectConverter_);

  function WorkflowCaseInfoConverter() {
    _classCallCheck(this, WorkflowCaseInfoConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WorkflowCaseInfoConverter).apply(this, arguments));
  }

  return WorkflowCaseInfoConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WorkflowCaseInfoConverter = WorkflowCaseInfoConverter;